<template>
  <el-config-provider :size="size" :z-index="zIndex">
    <ReplaceSql />
  </el-config-provider>
  

</template>

<script>
import ReplaceSql from './components/ReplaceSql.vue'
import { defineComponent } from 'vue'
import { ElConfigProvider } from 'element-plus'

export default defineComponent({
  name: 'App',
  components: {
    ReplaceSql,
    ElConfigProvider,
  },
  setup() {
    return {
      zIndex: 5000,
      size: 'small',
    }
  },
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
